import React from 'react';
import { Navbar } from '../components/Navbar';
import { HeroSection } from '../components/HeroSection';
import { AuthorityStrip } from '../components/AuthorityStrip';
import { ValueProposition } from '../components/ValueProposition';
import { ExpertiseSection } from '../components/ExpertiseSection';
import { CaseStudiesPreview } from '../components/CaseStudiesPreview';
import { LatestInsights } from '../components/LatestInsights';
import { EngagementPhilosophy } from '../components/EngagementPhilosophy';
import { ContactCTA } from '../components/ContactCTA';
import { Footer } from '../components/Footer';
import { SEO } from '../components/SEO';

export function HomePage() {
  return (
    <>
      <SEO page="home" />
      <Navbar />
      <main>
        <HeroSection />
        <AuthorityStrip />
        <ValueProposition />
        <ExpertiseSection />
        <CaseStudiesPreview />
        <EngagementPhilosophy />
        <LatestInsights />
        <ContactCTA />
      </main>
      <Footer />
    </>
  );
}
